module.exports = __webpack_public_path__ + "static/media/nBJMqvczUx.af7f96c2.jpg";